/**
 * Copyright Mántum All Rights Reserved.
 */
import Body from './body';
import Validator from '../validator';
import { ACTION_VALUE, EVENT_CLEAR, useGroupDispatch } from '../../group';
import { forwardRef, useRef, useImperativeHandle, useState } from 'react';

import type { Detail } from '@mantum/kanela';
import type { PropTypes } from './body';

export default forwardRef<Detail<unknown>, PropTypes>(
    function Chips(props, ref) {
        // prettier-ignore
        const { 
            name,
            optional = true
        } = props;

        const dispatch = useGroupDispatch();
        const inputRef = useRef<HTMLDivElement>(null);

        const [error, setError] = useState(props.error || false);

        useImperativeHandle(
            ref,
            () => {
                return {
                    name,
                    validable: !optional,
                    clear() {
                        setError(false);
                        if (name) {
                            dispatch({
                                type: EVENT_CLEAR,
                                content: [
                                    {
                                        action: ACTION_VALUE,
                                        target: name
                                    }
                                ]
                            });
                        }
                    },
                    validate() {
                        try {
                            const value = inputRef.current?.dataset?.value;
                            if (!value) {
                                throw new Error('The value is undefined');
                            }

                            const current = value.split(',');
                            const results = Array.isArray(current)
                                ? current.length > 0
                                : false;

                            setError(!results);
                            return results;
                        } catch {
                            setError(true);
                            return false;
                        }
                    },
                    value() {
                        try {
                            const value = inputRef.current?.dataset?.value;
                            if (!value) {
                                throw new Error('The value is undefined');
                            }

                            const current = value.split(',');
                            return Array.isArray(current) ? current : null;
                        } catch {
                            return null;
                        }
                    }
                };
            },
            [name, optional, dispatch]
        );

        return (
            <Validator
                error={error}
                message={props.validation?.message}
                type='radio'
            >
                <Body {...props} error={error} ref={inputRef} />
            </Validator>
        );
    }
);
